module.exports = __webpack_public_path__ + "/login_ui/img/tr-52e1e60443d734d14cfc96982c23a4e5.svg";